import { registerUtils } from '../application/nm'
let { freeze, isObject } = Object

export function deepFreeze(o) {
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
  //TODO - make sure to enable deepFreeze when last supported Chrome version will be 43
  /* eslint-disable*/
  freeze(o) // First freeze the object.
  for (let propKey in o) {
    let prop = o[propKey]
    if (
      !Object.prototype.hasOwnProperty.call(o, propKey) ||
      typeof prop !== 'object' ||
      Object.isFrozen(prop)
    ) {
      // If the object is on the prototype, not an object, or is already frozen,
      // skip it. Note that this might leave an unfrozen reference somewhere in the
      // object if there is an already frozen object containing an unfrozen object.
      continue
    }
    deepFreeze(prop) // Recursively call deepFreeze.
  }
  return o
  /* eslint-enable*/
}

export function makeEmptyObj(props = {}) {
  return Object.define(Object.create(null), props)
}

export function mapObject(obj, mapFunction) {
  let newObject = {}
  Object.keys(obj).forEach(function mapObjectKey(key) {
    Object.assign(newObject, mapFunction(key, obj[key]))
  })
  return newObject
}

export function snakeToCamel(s) {
  return s.replace(/(\_\w)/g, function(m) {
    return m[1].toUpperCase()
  })
}

export function snakeKeysToCamel(obj) {
  return mapObject(obj, (key, value) => {
    const camelKey = snakeToCamel(key)
    let tempObj = {}
    tempObj[camelKey] = value
    return tempObj
  })
}

export function noFalsyValue(key, val) {
  return val ? { [key]: val } : {}
}

export function* objectTouple(obj) {
  for (let key of Object.keys(obj)) {
    yield [key, obj[key]]
  }
}

export function reduceObjectEntriesInto(accumulator, reducerFn, objectToReduce) {
  return Object.entries(objectToReduce).reduce(reducerFn, accumulator)
}

export { makeEmptyObj as create }

export function classFactory(Class) {
  return freeze({
    create: function instantiate(...args) {
      return new Class(...args)
    },
  })
}

export const keys = (...objects) =>
  Array.of(...objects).reduce((allKeys, obj) => allKeys.concat(Object.keys(obj)), [])
export function serialize(obj, delimiter) {
  return Object.keys(obj)
    .reduce((keyValuePairs, key) => {
      let val = obj[key]
      if (val) {
        keyValuePairs.push(`${key}='${val}'`)
      }
      return keyValuePairs
    }, [])
    .join(delimiter)
}

export function map(obj, block) {
  let result = []
  for (let key in obj) {
    let value = obj[key]
    result.push(block(key, value))
  }
  return result
}

export function iterate(obj, callback, context) {
  if (context) {
    callback = callback.bind(context) // eslint-disable-line no-param-reassign
  }
  for (let [key, value] of objectTouple(obj)) {
    callback(value, key)
  }
  return obj
}

export { mapObject as objectMap }

export function namespacedConsts(nestedNames, seperator = ':', currentNamespace = '') {
  let namespacedNames = object.create()
  for (let key in nestedNames) {
    let currentName = `${currentNamespace}${seperator}${key}`
    let value = nestedNames[key]
    if (typeof value === 'object') {
      namespacedNames[key] = namespacedConsts(value, seperator, currentName)
    } else if (value) {
      namespacedNames[key] = currentName.slice(1)
    }
  }
  return deepFreeze(namespacedNames)
}

export function removeFalsyValues(obj) {
  return mapObject(obj, noFalsyValue)
}

export { isObject }
export const reduceObjectEntries = reduceObjectEntriesInto.bind(null, {})

let object = Object.assign(makeEmptyObj(), {
  snakeKeysToCamel,
  makeEmptyObj,
  create: makeEmptyObj,
  classFactory,
  deepFreeze,
  keys,
  serialize,
  map,
  iterate,
  objectMap: mapObject,
  noFalsyValue,
  removeFalsyValues,
  namespacedConsts,
  isObject,
  objectTouple,
  reduceObjectEntriesInto,
  reduceObjectEntries,
})

registerUtils({ object })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/object.js